<template>
  <div class="def-modal" :class="{ 'def-modal_padding': padding }">
    <slot />
    <span class="def-modal__close" @click="$emit('close')">
      <svg class="def-modal__icon"><use xlink:href="#svg-close"></use></svg>
    </span>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps(['padding']);
</script>

<style lang="scss" scoped>
.def-modal {
  height: 100%;
  overflow-y: auto;
  background-color: #fff;
  position: relative;
  width: 100%;
  &_padding {
    padding: 46px 16px;
    @include point-md {
      padding: 46px 32px;
    }
  }
  &__close {
    position: absolute;
    top: 12px;
    right: 16px;
    cursor: pointer;
    z-index: 1;
    @include point-md {
      right: 24px;
    }
    &:hover {
      svg {
        fill: var(--color-red);
      }
    }
  }
  &__icon {
    display: block;
    width: 24px;
    height: 24px;
    fill: var(--background-black);
    transition: 0.2s linear fill;
  }
}
</style>
